import { Box, Grid, Typography } from "@mui/material";
import { ResType } from "types";
import { useNavigate } from "react-router-dom";
import useTitle from "hooks/useTitle";
import { useQuery } from "react-query";
import { snack } from "components/toast";
import Loader from "components/Loader";
import TanInvalidateCheck from "views/atom-pro/Tan/Dashboard/invalidateCheck";
import TanFormsUdinAnalytics from "views/atom-pro/Tan/Dashboard/FormsUdinAnalytics";
import { incometaxConfigStatus } from "api/services/automation/dashboard-tan";
// import { getOrganizationPreference } from "api/services/common";
import TanFormsAnalytics from "views/atom-pro/Tan/Dashboard/FormsAnalytics";
import TanFormsCorrectionAnalytics from "views/atom-pro/Tan/Dashboard/FormsCorrectionAnalytics";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";
import AccessDenied from "views/atom-pro/Access/accessDenide";
import TempNotices from "views/atom-pro/Tan/Dashboard/TempNotices";
import TracesNotices from "views/atom-pro/Tan/Dashboard/TracesNotices";
import youtubeLogo from "./../../../assets/images/youtube-logo.png"

const TanDashboard = () => {
  useTitle("ATOM Pro | Dashboard");
  const navigate = useNavigate();
  const { permissions } = usePermissions();

  const { data, isLoading }: ResType = useQuery(
    ["incometax-tan-config-status"],
    incometaxConfigStatus,
    {
      // enabled:
      //   permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
      //   permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
    }
  );

  // const { data: incomeTaxAccess, isLoading: isLoadingIncomeTaxAccess }: ResType = useQuery(
  //   ["Income Tax Tan Access Check"],
  //   getOrganizationPreference,
  //   {
  //     onSuccess: (res: any) => {
  //       if (res?.data?.automationConfig?.tan === "YES") {
  //       } else {
  //         snack.error("Please subscribe Atom Pro Income tax TAN");
  //         navigate("/atom-pro/incomeTaxLimit");
  //       }
  //     },
  //     // enabled:
  //     //   permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //     //   permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS),
  //   }
  // );
  // if (
  //   !(
  //     permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) ||
  //     permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)
  //   )
  // ) {
  //   return <AccessDenied />;
  // }

  // if (isLoadingIncomeTaxAccess) return <Loader />;
  return (
    <Grid height="90vh" overflow="auto">
      {/* <Box m={1} display="flex" justifyContent="space-between">
        <Box display={"flex"}>
          <Box>
            <TanInvalidateCheck />
          </Box>
          <Box sx={{ borderRadius: 2 }} mx={2}>
            <Typography textAlign="center">
              <span style={{ fontWeight: "bold" }}>Total :</span> {data?.data?.totalLimit}
            </Typography>
            <Typography>
              <span style={{ fontWeight: "bold" }}>Used :</span> {data?.data?.presentClients}
              <span style={{ marginLeft: "20px", fontWeight: "bold" }}>Balance :</span>{" "}
              {data?.data?.difference}
            </Typography>
          </Box>
        </Box>
      </Box> */}
      <Grid container p={1} justifyContent="flex-end">
        {/* <Grid item display="flex" alignItems="center" xs={6}>
          <TanInvalidateCheck />
        </Grid> */}
        <Grid item>
          <Box    style={{marginRight:"10px"}}>
            <a href="https://youtu.be/eF_awS4prtE" target="_blank" rel="Atom Pro Income Tax YouTube video">
              <img
                src={youtubeLogo}
                alt="YouTube logo"
                style={{
                  width: '28px',
                      height: '24px',
                  cursor: 'pointer',
                  alignItems: "center",
                  marginRight:"5px"
                }}
              />
            </a>
          </Box>

        </Grid>

        <Grid item>
          <Box sx={{ borderRadius: 2 }}>
            <Typography textAlign="center">
              <span style={{ fontWeight: "bold" }}>Total :</span> {data?.data?.totalLimit}
            </Typography>
            <Typography>
              <span style={{ fontWeight: "bold" }}>Used :</span> {data?.data?.presentClients}
              <span style={{ marginLeft: "20px", fontWeight: "bold" }}>Balance :</span>{" "}
              {data?.data?.difference}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Box m={1}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TanFormsAnalytics />
              </Grid>
              {/* <Grid item xs={6}>
                <TanInvalidateCheck />
              </Grid> */}

              <Grid container direction="column" spacing={1} sx={{ height: "100%" }} item xs={6}>
                <Grid item sx={{ flex: 1 }}>
                  <TempNotices />
                </Grid>
                <Grid item sx={{ flex: 1 }}>
                  <TracesNotices />
                </Grid>
                <Grid item sx={{ flex: 1 }}>
                  <TanInvalidateCheck />
                </Grid>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TanFormsUdinAnalytics />
              </Grid>
              <Grid item xs={6}>
                <TanFormsCorrectionAnalytics />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};

export default TanDashboard;
